/**
 * Lead status display helpers — labels, colors, ordered column list.
 */

import type { LeadStatus } from "../types/leads";

export const LEAD_STATUS_ORDER: LeadStatus[] = [
  "new",
  "qualified_a",
  "qualified_b",
  "qualified_c",
  "warmed",
  "enrolled",
  "rejected",
];

export const LEAD_STATUS_LABEL: Record<LeadStatus, string> = {
  new: "Новый",
  qualified_a: "Квал. A",
  qualified_b: "Квал. B",
  qualified_c: "Квал. C",
  warmed: "Прогрет",
  enrolled: "Записан",
  rejected: "Отказ",
};

/** Ant Design Tag color for each status */
export const LEAD_STATUS_COLOR: Record<LeadStatus, string> = {
  new: "default",
  qualified_a: "blue",
  qualified_b: "geekblue",
  qualified_c: "purple",
  warmed: "orange",
  enrolled: "green",
  rejected: "red",
};
